var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutWide',[_c('div',[_c('SubNavbar',{attrs:{"page":"Utilities"}})],1),(_vm.showSearch)?_c('div',[_c('SelectCustomer')],1):_vm._e(),(_vm.showHistory)?_c('div',[_c('CustomerInvoices')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }